import apiClient from './api/apiService';
import { getUrlWithQueryParams } from './api/getUrlWithQueryParams';

const BASE_URL = '/v1/companies-models-access';

export const toggleOrderModelCompany = async (
  modelId: number,
  canOrderInternally?: boolean,
  canOrderExternally?: boolean
): Promise<any> => {
  const url = `${BASE_URL}/${modelId}`;
  const body = {
    can_order_internally: canOrderInternally ?? undefined,
    can_order_externally: canOrderExternally ?? undefined,
  };
  const { data } = await apiClient.patch<any>(url, body);

  return data.data;
};

export const enableOrderAllCompanies = async (
  modelId: number,
  companyId: number,
  canOrderInternally?: boolean,
  canOrderExternally?: boolean
): Promise<any> => {
  const url = `${BASE_URL}/all-companies`;
  const body = {
    model_id: modelId,
    company_seller_id: companyId,
    can_order_internally: canOrderInternally ?? undefined,
    can_order_externally: canOrderExternally ?? undefined,
  };
  const { data } = await apiClient.patch<any>(url, body);

  return data.data;
};

export const deleteModelCompany = async (modelId: number): Promise<any> => {
  const url = `${BASE_URL}/${modelId}`;
  const { data } = await apiClient.delete<any>(url);
  return data.data;
};

export const getEligibleCompaniesForModel = async (
  modelId: number,
  companyId: number,
  page: number,
  perPage: number,
  searchBy: string
): Promise<any> => {
  const url = `${BASE_URL}/eligible-companies`;
  const queryParamsObj = {
    model_id: modelId,
    company_seller_id: companyId,
    page: page,
    per_page: perPage,
    search_term: searchBy,
  };
  const fullUrl = getUrlWithQueryParams(url, queryParamsObj);
  const { data } = await apiClient.get<any>(fullUrl);

  return data.data;
};

export const addCompanyToModel = async (
  companyId: number,
  companyBuyerId: number,
  modelId: number
) => {
  const body = {
    company_seller_id: companyId,
    company_buyer_id: companyBuyerId,
    model_id: modelId,
  };
  const url = `${BASE_URL}`;
  const { data } = await apiClient.post(url, body);

  return data.data;
};
